(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ReserveLimit', ReserveLimit);

    ReserveLimit.$inject = ['$resource', 'DateUtils'];

    function ReserveLimit($resource, DateUtils) {
        var resourceUrl = 'api/reserveLimit/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createDate = DateUtils.convertDateTimeFromServer(data.createDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
